import React from 'react'
import PropTypes from 'prop-types'
import PressCardV3 from './PressCardV3'

function PressCardSetV3({ data }) {
  const { backgroundColor, pressLinks } = data
  return (
    <section className={`press-kit ${backgroundColor?.toLowerCase()}`}>
      <div className="container__inner">
        <div className="press-kit__content-box">
          {pressLinks.map((el, index) => (
            /* eslint-disable react/no-array-index-key */
            <PressCardV3 data={{ isKit: true, ...el }} key={index} />
          ))}
        </div>
      </div>
    </section>
  )
}

PressCardSetV3.propTypes = {
  data: PropTypes.object.isRequired
}

export default PressCardSetV3
